import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ONOTYBanner = _ref => {
  var {
    title,
    subtitle,
    hero = {
      filename: "",
      alt: ""
    },
    petal = {
      filename: "",
      alt: ""
    }
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "m-4 lg:m-8 py-12 lg:py-20 px-8 lg:px-16 relative",
    style: {
      background: "linear-gradient(90deg, rgba(0,153,218,1) 0%, rgba(66,180,121,1) 100%)"
    },
    children: [petal != null && petal.filename ? /*#__PURE__*/_jsx("img", {
      className: "hidden lg:block absolute top-0 left-0 h-36 z-0",
      src: petal.filename,
      alt: petal.alt
    }) : null, /*#__PURE__*/_jsxs("div", {
      className: "max-w-screen-2xl mx-auto flex flex-wrap justify-evenly gap-4 lg:gap-8",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "z-10 " + (hero.filename ? "max-w-lg" : "") + " flex flex-col justify-center gap-2",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-5xl lg:text-6xl font-bold w-full filter drop-shadow-xl text-white",
          children: title
        }), subtitle ? /*#__PURE__*/_jsx("p", {
          className: "text-xl lg:text-2xl font-thin filter drop-shadow-lg text-white",
          children: subtitle
        }) : null]
      }), hero.filename ? /*#__PURE__*/_jsxs("svg", {
        className: "z-10 min-h-96 max-w-100",
        height: "299",
        viewBox: "0 0 337 299",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M87 0H0V87H11.0925V11.0925H87V0Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M250 299H337V212H325.907V287.907H250V299Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("rect", {
          x: "29",
          y: "29",
          width: "279",
          height: "241",
          fill: "url(#pattern0)"
        }), /*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsx("pattern", {
            id: "pattern0",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /*#__PURE__*/_jsx("use", {
              xlinkHref: "#image0",
              transform: "translate(-0.000932781) scale(0.00177008 0.00204918)"
            })
          }), /*#__PURE__*/_jsx("image", {
            id: "image0",
            width: "566",
            height: "488",
            href: hero.filename,
            preserveAspectRatio: "xMidYMid slice"
          })]
        })]
      }) : null]
    })]
  });
};
//# sourceMappingURL=onoty_banner.js.map